module.exports = __webpack_public_path__ + "img/juegosysorteos-mx.3cb11154.png";